<template>
  <div class="artits content-box">
    <!-- <el-image src="/static/imgs/xwzx.png" fit="cover" class="saveimg w-img" /> -->
    <div class="w900 " v-if="form.translations">
      <div class="artitle cens-aaa">{{form.translations[0].title}}</div>
      <div class="save-time">发布时间：{{form.date_created}}</div>
      <div v-html="form.translations[0].content" class="isnewstyle"></div>
    </div>
    <div class="w900 borsart">
      <div class="backs" @click="$router.back()">返回上一页</div>
    </div>
    <div class="w900 nexta">
      <div @click="handlePrevious(index-1)">上一篇：<span
          v-if="index-1>=0">{{newsList[index-1].translations[0].title}}</span><span v-else class="ishui">没有了</span>
      </div>
      <div @click="handlePrevious(index+1)">下一篇：<span
          v-if="index+1<newsList.length">{{newsList[index+1].translations[0].title}}</span><span v-else
          class="ishui">没有了</span></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {



    data() {
      return {
        form: {},
        newsList: [],
        index: 0
      }
    },

    watch: {
      '$route': {
        handler(newValue) {
          if (newValue.path.includes('/news/article')) {

            this.getArt(newValue.params.id);





          }
        },
        immediate: true
      }
    },


    mounted() {

    },
    methods: {

      handlePrevious(num) {
        if (num >= this.newsList.length || num < 0) {
          return false
        }
        this.index = num
        this.getArt(this.newsList[num].id)

        this.goTop()

      },
      getArt(id) {
        this.$request('get', this.$otapi + 'items/articles/' + id + '?&fields=*.*&fields=images.*', {}, (res) => {
          if (res.status == 200) {
            this.form = res.data.data
            this.$request('get', this.$otapi +
              'items/articles?page=1&limit=10000&meta=*&fields=category&fields=id&fields=translations.title&filter={"status":"published"}&sort=-date_created&fields=image.filename_disk&fields=prefix&fields=date_created&sort=-id', {},
              (
                res) => {
                if (res.status == 200) {
                  this.newsList = res.data.data
                  this.index = this.newsList.findIndex(item => item.id == id)
                }
              })
          }
        })
      }
    },
    metaInfo() {
      return {
        title: '聚木网-新闻资讯'
      }
    }
  }
</script>

<style scoped>
  @import url('../../../static/css/infoart.css');
</style>



// WEBPACK FOOTER //
// src/components/news/article.vue